/**
 * Whether errors from this host belong in Sentry. Local runs (dev server, `vite preview` for the smoke test) and
 * Netlify deploy previews used to report into the same project as production and set off its alerts. Staging still
 * reports, under its own `environment`, so alerts can filter to production.
 */
export const shouldReportToSentry = (hostname: string): boolean => {
  const host = hostname.toLowerCase();
  if (host === 'localhost' || host === '127.0.0.1' || host === '[::1]' || host === '::1' || host === '0.0.0.0') {
    return false;
  }
  // deploy-preview-123--<site>.netlify.app
  if (/^deploy-preview-\d+--[^.]+\.netlify\.app$/.test(host)) {
    return false;
  }
  return true;
};
